<div class="center">
    <form [formGroup]="configFormGroup" class="flex-col width-800">
      <h2 class="center margin-y-10">Create subscription rules</h2>

      <div class="flex-row margin-y-10">
        <label class="width-50 font-20 bold">Flow:</label>
        <ng-select formControlName="creationFlow" name="creationFlow" class="flex-grow font-20 margin-l-10">
          <ng-option value="earningModel">Earning Model</ng-option>
          <ng-option value="daprResetMe">DAPR Reset Me</ng-option>
          <ng-option value="trialSubs">Trial Subs</ng-option>
        </ng-select>
      </div>

      <div class="flex-row margin-y-10">
        <label class="width-50 font-20 bold">State:</label>
        <ng-select formControlName="state" name="state" placeholder="Select state" class="flex-grow font-20 margin-l-10">
          <ng-option *ngFor="let item of states" [value]="item">{{item.name}}</ng-option>
        </ng-select>
      </div>

      <div class="flex-row margin-y-10">
        <label class="width-50 font-20 bold">City:</label>
        <ng-select formControlName="city" name="city" placeholder="Select city" class="flex-grow font-20 margin-l-10"
          [disabled]="!configFormGroup.get('state').value">
          <ng-option *ngFor="let item of cities" [value]="item">{{item.name}}</ng-option>
        </ng-select>
      </div>

      <div class="flex-row margin-y-10">
        <label class="width-50 font-20 bold">Mode:</label>
        <ng-select formControlName="mode" name="mode" placeholder="Select mode" class="flex-grow font-20 margin-l-10"
          [disabled]="!configFormGroup.get('city').value">
          <ng-option *ngFor="let item of modes" [value]="item">{{item.name}}</ng-option>
        </ng-select>
      </div>

      <div class="flex-row margin-y-10" *ngIf="!isDaprResetMe">
        <label class="width-50 font-20 bold">Category:</label>
        <ng-select formControlName="category" name="category" placeholder="Select category" class="flex-grow font-20 margin-l-10"
          [disabled]="!configFormGroup.get('mode').value">
          <ng-option *ngFor="let item of categories" [value]="item">{{item.name}}</ng-option>
        </ng-select>
      </div>

      <div class="flex-row margin-y-10" *ngIf="!isDaprResetMe && (isTrialSubs ? !showTrialSubs : showParentService)">
        <label class="width-50 font-20 bold">Service:</label>
        <ng-select formControlName="service" name="service" placeholder="Select service" class="flex-grow font-20 margin-l-10"
          [disabled]="!configFormGroup.get('category').value">
          <ng-option *ngFor="let item of services" [value]="item">{{item.name}}{{item.active ? '' : ' (inactive)'}}</ng-option>
        </ng-select>
      </div>
    </form>
</div>

<app-create-accessfee *ngIf="showAccessFee" [context]="accessFeeContext" [launch]="accessFeeLaunch" (launchServiceUnavailable)="onLaunchServiceUnavailable()" (launchConsumed)="onLaunchConsumed()"></app-create-accessfee>
<app-create-subscription *ngIf="showEarningPrepaid" [context]="prepaidContext" [launch]="launchParams" (launchServiceUnavailable)="onLaunchServiceUnavailable()" (launchConsumed)="onLaunchConsumed()"></app-create-subscription>
<app-create-dapr-reset *ngIf="showDaprPrepaid" [context]="daprContext"></app-create-dapr-reset>
<app-create-trial-subs *ngIf="showTrialSubs" [context]="trialContext"></app-create-trial-subs>
<app-create-postpaid *ngIf="showPostpaid" [context]="postpaidContext"></app-create-postpaid>
<app-authz-access-hint-footer [authzAccessHint]="authzAccessHint"></app-authz-access-hint-footer>
<app-toaster [config]="toasterService.toaster"></app-toaster>
